import React from 'react';
import { useTranslation } from 'react-i18next';
import { CheckCircle, Clock, AlertTriangle } from 'react-feather';
import { Task } from '../../../types/tasks';
import Card from '../../ui/Card';

interface Props {
  tasks: Task[];
}

const TaskStatusSummary: React.FC<Props> = ({ tasks }) => {
  const { t } = useTranslation();
  
  const statusSummary = [
    {
      status: 'completed',
      label: t('tasks.status.completed'),
      count: tasks.filter(t => t.status === 'completed').length,
      icon: CheckCircle,
      color: 'text-green-600',
      bgColor: 'hover:bg-green-50'
    },
    {
      status: 'in_progress',
      label: t('tasks.status.in_progress'),
      count: tasks.filter(t => t.status === 'in_progress').length,
      icon: Clock,
      color: 'text-blue-600',
      bgColor: 'hover:bg-blue-50'
    },
    {
      status: 'pending',
      label: t('tasks.status.pending'),
      count: tasks.filter(t => t.status === 'pending').length,
      icon: AlertTriangle,
      color: 'text-amber-600',
      bgColor: 'hover:bg-amber-50'
    }
  ];

  return (
    <Card className="bg-gradient-to-br from-white to-gray-50">
      <h3 className="text-lg font-semibold mb-4">{t('tasks.summary')}</h3>
      <div className="space-y-2">
        {statusSummary.map(({ status, label, count, icon: Icon, color, bgColor }) => (
          <div 
            key={status} 
            className={`flex items-center justify-between p-3 rounded-lg transition-colors duration-200 ${bgColor}`}
          >
            <div className="flex items-center space-x-3">
              <Icon className={`${color} w-5 h-5`} />
              <span className="font-medium">{label}</span>
            </div>
            <span className={`${color} font-semibold text-lg`}>{count}</span>
          </div>
        ))}
      </div>
    </Card>
  );
};

export default TaskStatusSummary;